import i18n from '@/plugins/i18n';
import acknowledgeService from '@/services/acknowledgeService';
export default {
  /**
   * Scrolls to list item which must have an id f_${fileId}
   * @param {Object} file
   * @param {Number} delay - optional delay in ms
   */
  scrollToFileOfFileList(file, delay) {
    if (file) {
      const scroll = () => {
        let el = document.getElementById(`f_${file.id}`);
        if (el) {
          let rect = el.getBoundingClientRect();
          let elTop = rect.top;
          let elBot = rect.bottom;
          let isVis = elTop >= 0 && elBot <= window.innerHeight;
          if (isVis) return;
          el.scrollIntoView({ block: 'start', behavior: 'smooth' });
        } else {
          console.log('did not find element with id', `f_${file.id}`);
        }
      };
      if (delay) {
        setTimeout(() => {
          scroll();
        }, delay);
      } else {
        scroll();
      }
    }
  },
  initiateDelayedMarkAsRead(dispatch, file, delay, show = true) {
    console.log('initiateDelayedMarkAsRead');
    const dispatchMarkAsRead = () => {
      const isToAcknowledge = acknowledgeService.isToAcknowledge(file);
      if (!isToAcknowledge) {
        let sendboxTitle = show ? i18n.t('action.read.msg', { title: file.title }) : '';
        let snackbarText = show ? i18n.t('action.document.read') : '';

        dispatch(`sendbox/markAsRead2`, { item: file, sendboxTitle, snackbarText, immediate: true }, { root: true });
      }
    };
    if (delay) {
      setTimeout(() => {
        dispatchMarkAsRead();
      }, delay);
    } else {
      dispatchMarkAsRead();
    }
  },
};
